var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useCallback } from 'react';
export var useModal = function (initialValue) {
    if (initialValue === void 0) { initialValue = false; }
    var _a = __read(useState(initialValue), 2), visible = _a[0], setVisible = _a[1];
    var handleShow = useCallback(function (evt) {
        if (evt)
            evt.persist ? evt.persist() : evt.stopPropagation();
        setVisible(true);
    }, []);
    var handleHide = useCallback(function (evt) {
        if (evt)
            evt.persist ? evt.persist() : evt.stopPropagation();
        setVisible(false);
    }, []);
    return { visible: visible, show: handleShow, hide: handleHide };
};
//# sourceMappingURL=modal.js.map